import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentHome: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg width={24} height={24} fill='none' viewBox='0 0 24 24' {...props}>
    <Path
      d='M10.55 2.532a2.25 2.25 0 012.9 0l6.75 5.692c.507.428.8 1.057.8 1.72v9.803a1.75 1.75 0 01-1.75 1.75h-3.5a1.75 1.75 0 01-1.75-1.75v-5.5a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25v5.5a1.75 1.75 0 01-1.75 1.75h-3.5A1.75 1.75 0 013 19.747V9.944c0-.663.293-1.292.8-1.72l6.75-5.692zm1.933 1.147a.75.75 0 00-.966 0L4.767 9.37a.75.75 0 00-.267.573v9.803c0 .138.112.25.25.25h3.5a.25.25 0 00.25-.25v-5.5c0-.967.784-1.75 1.75-1.75h3.5c.966 0 1.75.783 1.75 1.75v5.5c0 .138.112.25.25.25h3.5a.25.25 0 00.25-.25V9.944a.75.75 0 00-.267-.573l-6.75-5.692z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentHome
